// extracted by mini-css-extract-plugin
module.exports = {"sorter":"CollectionSorter_sorter__FUf1K","sortTrigger":"CollectionSorter_sortTrigger__C17Do","itemIcon":"CollectionSorter_itemIcon___37wK"};